// ui/Skeleton — load state shaped like the content (Design Standard v1, Doherty):
// no full-page spinners. variant: text | row | card; `count` repeats it.
import React from 'react';
import './ds.css';

export default function Skeleton({ variant = 'text', count = 1, width, className = '' }) {
  return (
    <div aria-busy="true" aria-label="Loading" className={className}>
      {Array.from({ length: count }, (_, i) => (
        <span key={i} className={`ds-skel ds-skel--${variant}`}
          style={{ width: width || (variant === 'text' ? `${70 + ((i * 13) % 25)}%` : '100%'), marginBottom: variant === 'row' ? 0 : 8 }} />
      ))}
    </div>
  );
}
